module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/band-and-orchestra-6b6eecde1688185630d81e4365bdf926.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/band-and-orchestra.png
// module id = UIVR
// module chunks = 12 16 18